import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Rooms.css';

// Import images
import roomsHero from '../assets/images/home.jpg';
import baphuthiMakholokoe from '../assets/images/Baphuthi&Makholokoe Room.jpg';
import makhoakhoaBasia from '../assets/images/Makhoakhoa&Basia Room.jpg';
import batlokoaBafokeng from '../assets/images/Batlokoa&Bafokeng Room.jpg';
import bataungBakoena from '../assets/images/Bataung&Bakoena.jpg';

const Rooms = () => {
    // Function to check if current date is in August
    const isAugust = () => {
        const now = new Date();
        const month = now.getMonth(); // 0 = January, 7 = August
        return month === 7; // August is month 7 (0-indexed)
    };

    // Function to get the promotion price based on date
    const getDisplayPrice = (originalPrice) => {
        if (isAugust()) {
            return "M800"; // Special August price
        }
        return originalPrice; // Regular price
    };

    const rooms = [
        {
            id: 1,
            name: "Baphuthi",
            description: "Bold, open, and contemporary.",
            price: "M900",
            image: baphuthiMakholokoe,
            amenities: ["Free WiFi", "Flat-screen TV", "Transparent Shower", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Transparent Shower"
        },
        {
            id: 2,
            name: "Bakubung",
            description: "Minimalist and airy.",
            price: "M900",
            image: baphuthiMakholokoe,
            amenities: ["Free WiFi", "Flat-screen TV", "Transparent Shower", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Transparent Shower"
        },
        {
            id: 3,
            name: "Batsoeneng",
            description: "Sleek, industrial-chic.",
            price: "M1,000",
            image: makhoakhoaBasia,
            amenities: ["Free WiFi", "Flat-screen TV", "Black Shower Door", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Black Shower Door"
        },
        {
            id: 4,
            name: "Basia",
            description: "Focus on relaxation and luxury.",
            price: "M950",
            image: makhoakhoaBasia,
            amenities: ["Free WiFi", "Flat-screen TV", "Private Bathtub", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Private Bathtub"
        },
        {
            id: 5,
            name: "Batloung",
            description: "Classic elegance.",
            price: "M950",
            image: batlokoaBafokeng,
            amenities: ["Free WiFi", "Flat-screen TV", "Private Bathtub", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Private Bathtub"
        },
        {
            id: 6,
            name: "Bafokeng",
            description: "Sophisticated and grounded.",
            price: "M1,000",
            image: batlokoaBafokeng,
            amenities: ["Free WiFi", "Flat-screen TV", "Black Shower Door", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Black Shower Door"
        },
        {
            id: 7,
            name: "Bataung",
            description: "Strong, modern accents.",
            price: "M1,000",
            image: bataungBakoena,
            amenities: ["Free WiFi", "Flat-screen TV", "Black Shower Door", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Black Shower Door"
        },
        {
            id: 8,
            name: "Bakoena",
            description: "Regal and polished.",
            price: "M1,000",
            image: bataungBakoena,
            amenities: ["Free WiFi", "Flat-screen TV", "Black Shower Door", "Tea/Coffee", "Daily Housekeeping", "Mini Fridge"],
            feature: "Black Shower Door"
        }
    ];

    return (
        <div className="rooms-page">
            <Header />
            
            {/* Hero Section */}
            <section className="rooms-hero">
                <div 
                    className="rooms-hero-image"
                    style={{
                        backgroundImage: `linear-gradient(rgba(44,62,80,0.7), rgba(44,62,80,0.7)), url(${roomsHero})`
                    }}
                ></div>
                <div className="hero-content">
                    <h1>Our Rooms</h1>
                    <p>Eight uniquely designed rooms for your comfort</p>
                </div>
            </section>

            {/* August Promotion Banner - Only shows in August */}
            {isAugust() && (
                <section className="promotion-banner">
                    <div className="container">
                        <div className="promotion-content">
                            <span className="promotion-badge">August Special</span>
                            <h3>All Rooms at M800 per Night</h3>
                            <p>Enjoy our premium rooms at a special rate. Offer valid from 01 August to 31 August.</p>
                        </div>
                    </div>
                </section>
            )}

            {/* Rooms Grid */}
            <section className="rooms-grid-section">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Our Rooms</span>
                        <h2>Comfort & Convenience</h2>
                        <p>Each room comes with premium amenities for a relaxing stay</p>
                        {isAugust() && (
                            <div className="promotion-note">All rooms at M800 per night this August</div>
                        )}
                    </div>
                    
                    <div className="rooms-container">
                        {rooms.map((room) => (
                            <div key={room.id} className="room-card">
                                <div className="room-image">
                                    <img src={room.image} alt={room.name} />
                                    <div className="room-price-tag">
                                        {getDisplayPrice(room.price)}
                                        <span>/night</span>
                                        {isAugust() && room.price !== "M800" && (
                                            <span className="original-price"> {room.price}</span>
                                        )}
                                    </div>
                                    <div className="room-feature-badge">{room.feature}</div>
                                    {isAugust() && (
                                        <div className="sale-badge">August Offer</div>
                                    )}
                                </div>
                                <div className="room-info">
                                    <h3>{room.name}</h3>
                                    <p className="room-description">{room.description}</p>
                                    
                                    <div className="room-amenities">
                                        {room.amenities.map((amenity, index) => (
                                            <span key={index} className="amenity">{amenity}</span>
                                        ))}
                                    </div>
                                    
                                    <div className="room-actions">
                                        <Link to={`/room/${room.id}`} className="btn btn-outline-dark">View More</Link>
                                        <Link to={`/bookings/${room.id}`} className="btn btn-primary">Book Now</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Check-in/Check-out Info */}
            <section className="check-info">
                <div className="container">
                    <div className="info-box">
                        <h3>Check-in / Check-out</h3>
                        <p>Check-in: <strong>2:00 PM</strong> | Check-out: <strong>10:00 AM</strong></p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="rooms-cta">
                <div className="container">
                    <h2>Ready to Book Your Stay?</h2>
                    <p>Contact us to reserve your room at Maison Mosh II</p>
                    <Link to="/contact" className="btn btn-primary btn-large">Contact Us</Link>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Rooms;